import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = [
    "priceInput", "totalAmount", "totalInterest", "monthlyPayment",
    "durationSelect", "optionsList", "selectedValue", "durationInput",
    "shortText", "expandedText"
  ]

  static values = {
    baseUrl: String,
    color: String,
    locale: String,
  }

  connect() {
    this.setupClickOutside();
    this.calculateLoan();

    this.clickOutsideHandler = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.clickOutsideHandler);
  }

  disconnect() {
    document.removeEventListener('click', this.clickOutsideHandler);
  }

  handleClickOutside(event) {
    if (!this.durationSelectTarget.contains(event.target)) {
      this.optionsListTarget.classList.add('hidden');
    }
  }

  setupClickOutside() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.optionsListTarget.classList.add('hidden');
      }
    });
  }

  toggleDurationSelect(e) {
    e.stopPropagation();
    this.optionsListTarget.classList.toggle('hidden');
  }

  selectDuration(e) {
    const value = e.target.getAttribute('data-value');
    const text = e.target.textContent;

    this.selectedValueTarget.textContent = text;
    this.durationInputTarget.value = value;
    this.optionsListTarget.classList.add('hidden');

    this.calculateLoan();
  }

  showExpandedText(e) {
    e.preventDefault();
    e.target.classList.add('hidden');
    this.shortTextTarget.classList.add('hidden');
    this.expandedTextTarget.classList.remove('hidden');
  }

  onPriceChange(e) {
    let value = e.target.value.replace(/[^0-9]/g, '');

    if (!value) {
      value = '0';
    }
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    value = `${value} €`;
    const cursorPos = e.target.selectionStart;
    e.target.value = value;
    e.target.setSelectionRange(cursorPos, cursorPos);
    this.calculateLoan();
  }

  onBlur(e) {
    this.formatValue(e.target);
  }

  formatValue(input) {
    let value = input.value.replace(/[^0-9]/g, '');

    if (!value) {
      value = '0';
    }
    const formattedValue = `${value.replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
    input.value = formattedValue;
    this.calculateLoan();
  }

  parsePrice(priceText) {
    return parseInt(priceText.replace(/[€\s.]/g, ''), 10);
  }

  async calculateLoan() {
    const price = this.parsePrice(this.priceInputTarget.value);
    const months = parseInt(this.durationInputTarget.value, 10);

    try {
      const response = await fetch(`/api/v1/finance/loan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({
          amount: price,
          locale: this.localeValue,
          num_installments: months,
        })
      });

      const data = await response.json();
      this.updateCalculatorValues(data, price);
    } catch (error) {
      console.error('API Error:', error);
    }
  }

  updateCalculatorValues(data) {
    this.totalAmountTarget.textContent = `${data.total_payment_formatted}`;
    this.totalInterestTarget.textContent = `${data.total_interest_formatted} (TAE ${data.tae_formatted})`;
    this.monthlyPaymentTarget.textContent = `${data.periodic_payment_formatted}`;

    this.shortTextTarget.innerHTML = this.shortText(data);
    this.expandedTextTarget.textContent = this.expandedText(data);
  }

  shortText(data) {
    const targetPhrase = "desde la solicitud.";
    const endIndex = data.disclaimer.indexOf(targetPhrase);
    const index = endIndex === -1 ? 100 : endIndex + targetPhrase.length;
    return data.disclaimer.substring(0, index);
  }

  expandedText(data) {
    return data.disclaimer;
  }

  openCalculator() {
    window.open(`${this.baseUrlValue}/<%= @widget.widgetable.name %>`, '_blank');
  }
}
